import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../redux/rootReducers';
import { PupilFormType } from '../../../containers/pupil-details/PupilDetails';
import { SegmentedControl } from '@digital/react-aviva-atom';
import { YesNoOptions } from '../../../redux/user-selection/userSelection';

interface OwnProps {
    formType?: PupilFormType;
    // tslint:disable-next-line:no-any
    setFieldValue: (field: string, value: any) => void;
    sameDetails?: YesNoOptions;
}

export type Props = OwnProps;

export class CardHolderFields extends React.PureComponent<Props> {

    render() {

        const { sameDetails, formType, setFieldValue} = this.props;

        const sameDetailsOptions = [
            {title: 'Yes', value: YesNoOptions.Yes},
            {title: 'No', value: YesNoOptions.No}
        ];

        return (
            <div data-testid="card-holder-fields">
                <h3>
                    Cardholder Details
                </h3>
                <hr className="a-keyline-divider--horizontal-solid-light"/>
                {formType === PupilFormType.Pupil &&
                <div className="m-form-row">
                    <div className="m-form-row__content">
                        <label className="a-label">
                            Are the cardholder details the same as the pupil's contact details?
                        </label>

                        <SegmentedControl
                            options={sameDetailsOptions}
                            onChange={(val) => setFieldValue('sameDetails', val)}
                            value={sameDetails}
                        />
                    </div>
                </div>
                }
            </div>
        );
    }
}

export function mapStateToProps(state: RootState) {
    return {
        counties: state.counties.countiesAvailable
    };
}

export default connect<{}, {}>(mapStateToProps, {})(CardHolderFields);